import { useContext, useEffect, useState } from "react";
import { INewPersonalHistory, IPregnancy } from "../../../../../../libs/data-access/types";
import { PatientContext } from "../../../../patientFromContext/PatientsContext";
import { useLocation, useSearchParams } from "react-router-dom";
import { useDirectusApi } from "../../../../../../libs/data-access";
import { showToast } from "../../../../../../utils/utility";
import { generateDynamicExcelObject } from "../../../../../../utils/excelMapper/excelMapper";
import { ExcelMapping } from "../../../../../../utils/excelMapper/constants";

const DefaultHistory: INewPersonalHistory = {
  user_id: "",
  visit_id: "",
  state_of_residence: "",
  birth_state: "",
  residence_during_childhood: "",
  lives_in: "",
  marital_status: "",
  religion: "",
  ethnicity: "",
  no_of_adults_family_member: '',
  no_of_child_family_member: '',
  patient_education: "",
  patient_occupation: "",
  kuppuswamy_scale_education_of_the_head: "",
  kuppuswamy_scale_occupation_of_the_head: "",
  kuppuswamy_scale_updated_monthly_family_income: "",
  Socio_economic_class: "",
  vehicle: "",
  reproductive_h_per_o: [
    {
      menarche: '',
      menopause: '',
      regular: null,
      age_at_marriage: '',
      age_at_first_child_birth: '',
      age_at_last_child_birth: '',
      total_no_of_children: '',
      total_no_of_abortions: '',
      breast_feed_months: '',
      gynaecological_surgery: null,
      which_surgery: "",
      age_at_which_surgery_done: ''
    },
  ],
  pregnancies_history: [],
  anthropometric_measurement: [
    {
      height_cm: "-cm",
      weight_kg: "",
      waist_circumference: "-cm",
      hip_circumference_cm: "-cm",
      bmi_kg_per_m_square: "",
      blood_pressure: "",
      tooth_count: "",
      mid_arm_circumference_cm: "-cm",
      weight_height_ratio_kg_m_sqaure: "",
    }
  ],
  nearest_health_care_center: [],
  recruitment_method: "",
  water_source: "",
  health_insurance_name: "",
  opd_visit_coverage: "",
  cashless_coverage: "",
  ration_card_type: "",
};

const DefaultNewPregnancy: IPregnancy = {
  duration_of_pregnancy: "",
  how_did_the_pregnancy_end: "",
  type_of_delivery: "",
  complications: "",
};

interface IAnthropometricUnits {
  height: string;
  weight: string;
  waist: string;
  hip: string;
}
export default function usePersonalHistory() {

  const {
    activeTab,
    setIsBtnLoading,
    isBtnNextClick,
    handleNextTab,
    isFormUpdating,
    setIsFormUpdating,
  } = useContext(PatientContext);

  const [searchParams] = useSearchParams();
  const patient_id = searchParams.get("patient_id");
  const visit_id = searchParams.get("visit_id");
  const location = useLocation();
  const gender = location.state?.gender?.toLowerCase();
  const { postDirectData, fetchDirectData, patchDirectData } = useDirectusApi();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isOpenModalPregnancies, setIsOpenModalPregnancies] = useState<boolean>(false);
  const [personalHistory, setPersonalHistory] = useState<INewPersonalHistory>(DefaultHistory);
  const [newPregnancies, setNewPregnancies] = useState<IPregnancy>(DefaultNewPregnancy);
  const [selectedPregnancyIndex, setSelectedPregnancyIndex] = useState<number | undefined>(undefined);
  const [anthropometricUnits, setAnthropometricUnits] = useState<IAnthropometricUnits>({
    height: "cm",
    weight: "cm",
    waist: "cm",
    hip: "cm",
  });

  const [errors, setErrors] = useState<any>({});



  useEffect(() => {

    if (personalHistory.id) {
      const excelData = generateDynamicExcelObject(personalHistory, ExcelMapping)
      console.log('exceldata is', excelData)
    }

  }, [personalHistory])

  useEffect(() => {
    if (activeTab === "personal_history") {
      getDetailsByVisitId()
    }
  }, [activeTab])

  useEffect(() => {
    if (isBtnNextClick && activeTab === "personal_history") {
      handelSubmitPersonalHistory()
    }
  }, [isBtnNextClick])


  useEffect(() => {
    validateAll();
  }, [personalHistory])

  useEffect(() => {
    setPersonalHistory((prev) => (
      {
        ...prev,
        Socio_economic_class:
          String(
            (personalHistory?.kuppuswamy_scale_education_of_the_head ? +personalHistory?.kuppuswamy_scale_education_of_the_head?.split("+")[1] : 0)
            +
            (personalHistory?.kuppuswamy_scale_education_of_the_head ? +personalHistory?.kuppuswamy_scale_occupation_of_the_head?.split("+")[1] : 0)
            +
            (personalHistory?.kuppuswamy_scale_updated_monthly_family_income ? +personalHistory?.kuppuswamy_scale_updated_monthly_family_income?.split("+")[1] : 0)
          )
      }));

  }, [personalHistory?.kuppuswamy_scale_education_of_the_head, personalHistory?.kuppuswamy_scale_occupation_of_the_head, personalHistory?.kuppuswamy_scale_updated_monthly_family_income])

  //    HANDLER FUNCTION

  const handleChangeUnits = (key: keyof IAnthropometricUnits, value: string) => {
    setAnthropometricUnits((prev) => ({ ...prev, [key]: value }));
  }

  const calculateValueByUnit = (value: number, unit: string) => {
    if (unit?.toLowerCase() === "cm") {
      return value
    }
    else if (unit?.toLowerCase() === "inches") {
      const finalValue = value * 0.3937008
      return finalValue.toFixed(2)
    }
    else if (unit?.toLowerCase() === "feet") {
      const finalValue = value * 0.0328084
      return finalValue.toFixed(2)
    }
    return 0
  }

  const validateField = (key: string, subKey: string | undefined, value: any) => {
    let errorMsg = "";
    const intValue = parseInt(value);
    const numValue = Number(value);

    if (gender === "male" && key === "reproductive_h_per_o") {
      setPersonalHistory((prev) => ({ ...prev, reproductive_h_per_o: [] }));
      return
    }

    if (gender === "male" && key === "pregnancies_history") {
      setPersonalHistory((prev) => ({ ...prev, pregnancies_history: [] }));
      return
    }

    if (key === "reproductive_h_per_o") {
      if (subKey === "menarche") {
        if (intValue < 9 || intValue > 18) errorMsg = "Menarche age should be between 9 and 18";
      } else if (subKey === "menopause") {
        if (intValue < 30 || intValue > 60) errorMsg = "Menopause age should be between 30 and 60";
      } else if (subKey === "age_at_marriage") {
        if (intValue < 10 || intValue > 60) errorMsg = "Age at marriage should be between 10 and 60";
      } else if (subKey === "age_at_first_child_birth") {
        if (intValue < 16 || intValue > 60) errorMsg = "Age at first child birth should be between 16 and 60";
      } else if (subKey === "age_at_last_child_birth") {
        if (intValue < 10 || intValue > 60) errorMsg = "Age at last child birth should be between 10 and 60";
      } else if (subKey === "total_no_of_children") {
        if (intValue > 20) errorMsg = "Value must be less than 20.";
      } else if (subKey === "total_no_of_abortions") {
        if (intValue > 20) errorMsg = "Value must be less than 20.";
      } else if (subKey === "age_at_which_surgery_done") {
        if (intValue > 120) errorMsg = "Age must be 120 or less.";
      }
    } else if (key === "anthropometric_measurement") {
      const isValEmpty = !value || value === "-cm" || String(value).trim() === "";
      if (isValEmpty) {
        errorMsg = "";
      } else if (subKey === "height_cm") {
        const heightVal = Number(value.split("-")[0]);
        if (heightVal < 90 || heightVal > 250) errorMsg = "Height should be between 90cm and 250cm";
      } else if (subKey === "weight_kg") {
        if (numValue < 20 || numValue > 250) errorMsg = "Weight should be between 20kg and 250kg";
      } else if (subKey === "waist_circumference") {
        const waistVal = Number(value.split("-")[0]);
        if (waistVal < 30 || waistVal > 200) errorMsg = "Waist circumference should be between 30cm and 200cm";
      } else if (subKey === "hip_circumference_cm") {
        const hipVal = Number(value.split("-")[0]);
        if (hipVal < 30 || hipVal > 250) errorMsg = "Hip circumference should be between 30cm and 250cm";
      }
    } else if (key === "duration_of_pregnancy") {
      if (numValue > 10) errorMsg = "Value must be less than 10.";
    }

    setErrors((prev: any) => ({
      ...prev,
      [key]: {
        ...(prev[key] || {}),
        [subKey || key]: errorMsg,
      }
    }));
    return errorMsg;
  };

  const validateAll = () => {
    let hasError = false;
    const reproductive = personalHistory.reproductive_h_per_o?.[0] || {};
    const anthropometric = personalHistory.anthropometric_measurement?.[0] || {};

    const fieldsToValidate = [
      { key: "reproductive_h_per_o", subKey: "menarche", value: reproductive.menarche },
      { key: "reproductive_h_per_o", subKey: "menopause", value: reproductive.menopause },
      { key: "reproductive_h_per_o", subKey: "age_at_marriage", value: reproductive.age_at_marriage },
      { key: "reproductive_h_per_o", subKey: "age_at_first_child_birth", value: reproductive.age_at_first_child_birth },
      { key: "reproductive_h_per_o", subKey: "age_at_last_child_birth", value: reproductive.age_at_last_child_birth },
      { key: "reproductive_h_per_o", subKey: "total_no_of_children", value: reproductive.total_no_of_children },
      { key: "reproductive_h_per_o", subKey: "total_no_of_abortions", value: reproductive.total_no_of_abortions },
      { key: "reproductive_h_per_o", subKey: "age_at_which_surgery_done", value: reproductive.age_at_which_surgery_done },
      { key: "anthropometric_measurement", subKey: "height_cm", value: anthropometric.height_cm },
      { key: "anthropometric_measurement", subKey: "weight_kg", value: anthropometric.weight_kg },
      { key: "anthropometric_measurement", subKey: "waist_circumference", value: anthropometric.waist_circumference },
      { key: "anthropometric_measurement", subKey: "hip_circumference_cm", value: anthropometric.hip_circumference_cm },
    ];

    fieldsToValidate.forEach(field => {
      if (field.value !== "" && field.value !== undefined && field.value !== "-cm") {
        if (validateField(field.key, field.subKey, field.value) !== "") {
          hasError = true;
        }
      }
    });

    return hasError;
  };

  const handelChangeHistory = (
    key:
      | keyof INewPersonalHistory,
    value: number | string | boolean | any[] | null,
    subKey?: string,
    index?: number
  ) => {
    if (subKey) {
      validateField(key, subKey, value);
      const data: any[] = JSON.parse(JSON.stringify(personalHistory?.[key]));
      const firstIndex = index ? data[index] : data[0];
      data[index ?? 0] = { ...firstIndex, [subKey]: value };
      setPersonalHistory((prev) => ({ ...prev, [key]: data }));
    } else {
      setPersonalHistory((prev) => ({ ...prev, [key]: value }));
    }

  };

  const handelSubmitPersonalHistory = () => {
    if (patient_id && visit_id) {
      const hasValidationError = validateAll();
      const allErrors = Object.values(errors).flatMap((group: any) =>
        typeof group === 'object' ? Object.values(group) : [group]
      );

      if (hasValidationError || allErrors.some((error) => error !== "")) {
        showToast({
          type: "error",
          message: "Please fix all validation errors before submitting.",
        });
        return;
      }
      let payload: INewPersonalHistory = {
        ...personalHistory,
        user_id: patient_id,
        visit_id: visit_id,
      };
      savePersonalHistory(payload);
    }
  };

  const handleChangePregnancies = (key: string, value: string | number) => {

    if (key === "duration_of_pregnancy") {
      validateField(key, undefined, value);
    }
    if (key === "default") {
      setNewPregnancies(DefaultNewPregnancy);
    } else {
      setNewPregnancies((prev) => ({ ...prev, [key]: value }));
    }
    // const data = JSON.parse(JSON.stringify(personalHistory.pregnancies_history));
    // data[selectedPregnancyIndex ?? 0] = {
    //   ...data[selectedPregnancyIndex ?? 0],
    //   [key]: value,
    // };
    // setPersonalHistory((prev) => ({ ...prev, pregnancies_history: data }));
  };

  function calculateBMI(weight_kg: number, height_cm: number) {
    // Convert height from centimeters to meters
    var height_m = height_cm / 100;

    // Calculate BMI
    var bmi = weight_kg / (height_m * height_m);

    // Return BMI value
    handelChangeHistory(
      "anthropometric_measurement",
      bmi?.toFixed(2) + "",
      "bmi_kg_per_m_square"
    )
    // setTextInputs({
    //   ...textInputs,
    //   bmi_kg_per_m_square: bmi?.toFixed(2) + "",
    // });
  }

  function calculateWeightToHeightRatio(waist_cm: number, hip_cm: number) {
    var ratio = waist_cm / hip_cm;

    handelChangeHistory(
      "anthropometric_measurement",
      ratio?.toFixed(2) + "",
      "weight_height_ratio_kg_m_sqaure"
    )
    // setTextInputs({
    //   ...textInputs,
    //   weight_height_ratio_kg_m_sqaure: ratio?.toFixed(2) + "",
    // });
  }

  // APIFunction
  const getDetailsByVisitId = async () => {
    setIsLoading(true)
    const res = await fetchDirectData(`items/demographic_information?filter[visit_id][_eq]=${visit_id}`)
    if (res.isSuccess) {
      if (res?.data?.length) {
        setIsFormUpdating(true)
        let data: INewPersonalHistory = res?.data[0]
        setPersonalHistory(data);
      }
      else {
        setIsFormUpdating(false)
      }
    }
    else {
      showToast({
        type: "error",
        message: "Something went wrong"
      })
    }
    setIsLoading(false)
  }

  const savePersonalHistory = async (payload: INewPersonalHistory) => {
    setIsBtnLoading(true);
    if (isFormUpdating) {
      const res = await patchDirectData(`items/demographic_information/${personalHistory?.id}`, payload);
      if (res.isSuccess) {
        showToast({
          type: "success",
          title: "Updated successfully",
          message: "Patient personal history updated",
        });
        handleNextTab();
      } else {
        showToast({
          type: "error",
          message: res?.message || "Failed to add personal history",
        });
      }
    }
    else {
      const res = await postDirectData(`items/demographic_information`, payload);
      if (res.isSuccess) {
        showToast({
          type: "success",
          title: "Uploaded successfully",
          message: "Patient personal history added",
        });
        handleNextTab();
      } else {
        showToast({
          type: "error",
          message: res?.message || "Failed to add personal history",
        });
      }
    }
    setIsBtnLoading(false);
  };
  return {
    isLoading,
    personalHistory,
    handelChangeHistory,
    isOpenModalPregnancies,
    setIsOpenModalPregnancies,
    newPregnancies,
    handleChangePregnancies,
    calculateBMI,
    calculateWeightToHeightRatio,
    anthropometricUnits,
    handleChangeUnits,
    calculateValueByUnit,
    selectedPregnancyIndex,
    setSelectedPregnancyIndex,
    errors
  };
}
